import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useLayerService } from "../../../../../hooks";
import { RouteLineImport } from "../../../../../types/RouteLine/RouteLineImport";
import StyledToggle from "../../../../boundarySelection/ViewTools/StyledToggle";
import useGetRouteLineParams from "./GetRouteLineParams";
import { useRouteLineContext } from "../../../../../context/MapViews/RouteLine/RouteLineContext";

const RouteLineQuarterDropdown = () => {
  const layerService = useLayerService();
  const [imports, setImports] = useState<RouteLineImport[]>([]);
  const { quarter, handleSelect } = useGetRouteLineParams();
  const { setSelectedRouteLine } = useRouteLineContext();

  useEffect(() => {
    layerService.GetRouteLineImportQuarters().then((response) => {
      setImports(response);
      if (quarter === null && response.length > 0) {
        handleSelect(response[0].importQuarter);
      }
    });
  }, [layerService]);

  const handleChange = (selected: string | null) => {
    if (selected) {
      handleSelect(selected);
      setSelectedRouteLine(null);
    }
  };

  return (
    <Dropdown onSelect={handleChange}>
      <StyledToggle
        className="view-tools-dropdown fs-6 bg-light text-black"
        size="lg"
      >
        <span className="toggle-text">
          {quarter ?? (imports.length === 0 ? "Loading..." : "Select Quarter")}
        </span>
      </StyledToggle>

      <Dropdown.Menu className="w-100 fs-6">
        {imports.map((i) => (
          <Dropdown.Item
            key={i.importQuarter}
            eventKey={i.importQuarter}
            active={i.importQuarter === quarter}
          >
            {i.importQuarter}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default RouteLineQuarterDropdown;
